/// <amd-module name="typeahead/core/StripingConfiguration"/>

// This interface is to enforce restrictions included
// as keys while running experiment or global rollout
import {Experiment} from "Experiment";

export interface IStripingConfiguration {
    clients?: string[];
    siteids?: string[];
    tabs?: string[];
    lobs?: string[] | ReadonlyArray<string>;
    packageTypes?: ReadonlyArray<string | undefined>;
    locales?: string[];
    deviceTypes?: string[];
    experiment?: Experiment;
}

export function getExperiments(configurations: IStripingConfiguration[]): Experiment[] {
    if (configurations && configurations.length) {
        return configurations.map((config) => {return config.experiment; })
                             .filter((experiment) => {return !!experiment; });
    }
    return [];
}
